// Board is 3x3 array, the model in MVC
let Board = [
    [],
    [],
    []
]

let gamemode = "local"

let player = true // true is o, false is x. easy to toggle with !
let me = true // should be immutable after set
let won = false


const Controller = {
    place(piece, x, y, otherPlayer = false) {
        // piece can be x or else
        if (!Board[x][y] && !won) { // if place is not already placed and nobody has won
            // actually placing the pieces
            Board[x][y] = piece
            View.place(piece, x, y)

            // check win status
            let didWin = this.didWin()
            View.didWin(didWin)

            if (gamemode === "online" && !otherPlayer) {
                socket.emit("move", {
                    me,
                    coords: [x, y]
                })
            }

            !didWin.didWin && this.swapPlayer()
        }

    },
    swapPlayer() {
        player = !player
        View.swapPlayer(player)
    },
    didWin() {
        let col, row, crossTL, crossTR
        for (let i = 0; i < 3; i++) {
            col = {
                win: Board[i][0] && Board[i][0] === Board[i][1] && Board[i][0] === Board[i][2],
                no: i
            }
            row = {
                win: Board[0][i] && Board[0][i] === Board[1][i] && Board[0][i] === Board[2][i],
                no: i
            }
            crossTL = {
                win: Board[0][0] && Board[0][0] === Board[1][1] && Board[0][0] === Board[2][2],
                no: i
            }

            crossTR = {
                win: Board[2][0] && Board[2][0] === Board[1][1] && Board[2][0] === Board[0][2],
                no: i
            }

            if (col.win ||
                row.win ||
                crossTL.win ||
                crossTR.win) {
                won = true
                return {
                    didWin: true,
                    message: `<span class="${player ? "circled" : "crossed"} player"></span> won!`
                }
            }
        }

        // check for tie
        let squaresFilled = 0
        Board.forEach((row) => {
            row.forEach((square) => {
                square && squaresFilled++ // increment squarefilled if the square is not undefined
            })
        })
        if (squaresFilled === 9) {
            won = true
            return {
                didWin: true,
                message: "Tie."
            }
        }

        return {
            didWin: false
        }
    },
    restart(broadcast = true) {
        Board = [
            [],
            [],
            []
        ]
        player = true
        won = false
        View.restart()
        View.swapPlayer(true)

        if (gamemode === "online" && broadcast) {
            console.log("emitting restart");

            socket.emit("move", {
                restart: true
            })
        }
    }
}

// 0,0 is top left
const View = {
    place(piece, x, y) {
        // piece can be x or else
        piece = (piece === "o" ? "circled" : "crossed")
        const square = document.querySelector(`.row-${y}>.col-${x}`)
        square.classList.add("placed", piece)
        this.updatedStatus()
    },
    swapPlayer(player) {
        const playerElement = document.querySelector(".player")
        playerElement.classList.remove(player ? "crossed" : "circled") // player is true, so currenty o, so was x
        playerElement.classList.add(player ? "circled" : "crossed")
        const hoverElements = document.querySelectorAll(".col .after")
        const hoverElementsArray = [...hoverElements]

        hoverElementsArray.forEach((hoverElement) => {
            hoverElement.classList.remove(player ? "crossed" : "circled")
            hoverElement.classList.add(player ? "circled" : "crossed")
        })
        this.updatedStatus()
    },
    updatedStatus() {
        const statusElement = document.querySelector(".status")
        statusElement.classList.add("updated")
        window.setTimeout(() => {
            statusElement.classList.remove("updated")
        }, 300)
    },
    updateStatus(status) {
        const statusElement = document.querySelector(".status")
        statusElement.innerHTML = status
    },
    didWin(status) {
        if (status.didWin) {
            this.updateStatus(status.message)
        }
    },
    restart() {
        const board = document.querySelectorAll(".col")
        for (const square of board) {
            try {
                square.classList.remove("crossed", "circled", "placed")
            } catch (error) {}
        }
        this.updateStatus(`Player <span class="circled player"></span>`)
        this.updatedStatus()

    },
    hideOverlay(className) {
        const overlay = document.querySelector(className)
        overlay.classList.add("hide")
        window.setTimeout(() => {
            overlay.classList.add("none")
        }, 200)
    },
    showOverlay(className) {
        const overlay = document.querySelector(className)
        overlay.classList.remove("hide", "none")
    }
}

const game = (e) => {
    console.log(player, me);

    let coords = []
    const targetClasses = [...e.target.classList]
    const targetParentClasses = [...e.target.parentElement.classList]
    coords[0] = parseInt(targetClasses.filter(className => className.includes("col-"))[0].substring(4, 5)) // x-coord
    coords[1] = parseInt(targetParentClasses.filter(className => className.includes("row-"))[0].substring(4, 5)) // y-coord
    console.log(`Should I be placing a piece? ${player === me}`);

    if (gamemode === "local" || player === me) {
        Controller.place(player ? "o" : "x", coords[0], coords[1])
    }
}

const boardElement = document.querySelector(".board")
boardElement.onclick = boardElement.onkeypress = (e) => {
    game(e)
}

boardElement.onmouseover = (e) => {
    e.target.firstChild.style.opacity = "0.3"
}

boardElement.onmouseout = (e) => {
    e.target.firstChild.style.opacity = "0"
}

const restartButton = document.querySelector(".restart")
restartButton.onclick = () => {
    Controller.restart()
}

const localElement = document.querySelector(".local-multiplayer")
localElement.onclick = localElement.onkeypress = () => {
    View.hideOverlay(".mode-select")
}

const onlineElement = document.querySelector(".online-multiplayer")
onlineElement.onclick = onlineElement.onkeypress = () => {
    View.hideOverlay(".mode-select")
    View.showOverlay(".online")
}

const backElement = document.querySelector(".back")
backElement.onclick = () => {
    window.location.reload()
}

const displayGameIdElement = document.querySelector(".display-game-id")

const io = require("socket.io-client")
const socket = io.connect("https://ttt.eamonma.com")

const thisPlayerElement = document.querySelector(".this-player")

const startNewElement = document.querySelector(".start-new")
startNewElement.onclick = () => { // player A
    gamemode = "online"
    socket.emit("joinGame", {
        id: socket.id,
        newGame: true,
        gameId: undefined
    })

    startNewElement.style.display = "none"
    joinGameFormElement[0].style.display = "none"
    joinGameFormElement[1].style.display = "none"

    socket.on("connection", ({
        gameId
    }) => {
        document.querySelector(".game-id").innerHTML = `Tell your friends to join <input class="game-id-field" readonly value=${gameId}>`
        displayGameIdElement.textContent = `Game ID: ${gameId}`
    })

    socket.on("joined", (msg) => {
        if (msg.gameType === "existing") {
            View.hideOverlay(".online")
        }
        me = true
    })

    thisPlayerElement.innerHTML = `You are Player <span class="circled player"></span>`
}

const joinGameFormElement = document.querySelector(".join-game-form")
joinGameFormElement.onsubmit = (e) => { // player B
    e.preventDefault()
    gamemode = "online"
    const gameId = e.target[0].value.trim()

    socket.emit("joinGame", {
        id: socket.id,
        newGame: false,
        gameId
    })

    socket.on("joined", () => {
        View.hideOverlay(".online")
        me = false
        displayGameIdElement.textContent = `Game ID: ${gameId}`
    })

    thisPlayerElement.innerHTML = `You are Player <span class="crossed player"></span>`
}

socket.on("move", (msg) => {
    if (msg.restart) {
        return Controller.restart(false)
    }

    player = msg.me
    coords = msg.coords
    Controller.place(player ? "o" : "x", coords[0], coords[1], true)
})